import { createBaseApi } from '../baseApi';
import { API_ENDPOINTS } from '../../../utils/config';

// Create base credit API
const creditApi = createBaseApi('creditApi');

// Enhanced API with credit endpoints
export const enhancedCreditApi = creditApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get current user's credit balance
    getCreditBalance: builder.query({
      query: () => ({
        url: API_ENDPOINTS.CREDIT.BALANCE,
        method: 'GET'
      }),
      providesTags: ['Credit'],
      transformResponse: (response) => ({
        balance: response.balance,
        periodStart: response.periodStart,
        daysUntilReset: response.daysUntilReset,
        maxCredits: response.maxCredits
      })
    }),
    // Get current user's referral info (code, link, stats)
    getReferralInfo: builder.query({
      query: () => ({
        url: API_ENDPOINTS.CREDIT.REFERRAL,
        method: 'GET'
      }),
      providesTags: ['Credit', 'Referral'],
      transformResponse: (response) => ({
        referralCode: response.referralCode,
        referralLink: response.referralLink,
        referralCreditsEarned: response.referralCreditsEarned,
        referralCount: response.referralCount,
        creditsPerReferral: response.creditsPerReferral
      })
    }),
    // List available credit packages
    getCreditPackages: builder.query({
      query: () => ({
        url: API_ENDPOINTS.CREDIT.PACKAGES,
        method: 'GET'
      }),
      transformResponse: (response) => response.packages || []
    }),
    // Purchase a credit package (creates Stripe PaymentIntent)
    purchaseCreditPackage: builder.mutation({
      query: ({ packageId, savedPaymentMethodId, promoCode }) => ({
        url: API_ENDPOINTS.CREDIT.PURCHASE,
        method: 'POST',
        // Only the code travels — the backend re-resolves it and owns the price.
        body: { packageId, ...(savedPaymentMethodId && { savedPaymentMethodId }), ...(promoCode && { promoCode }) }
      })
    }),
    // Confirm a credit package purchase after Stripe payment
    confirmCreditPurchase: builder.mutation({
      query: ({ paymentIntentId }) => ({
        url: API_ENDPOINTS.CREDIT.CONFIRM,
        method: 'POST',
        body: { paymentIntentId }
      }),
      invalidatesTags: ['Credit']
    }),
    // --- Saved Payment Method endpoints ---
    getSavedPaymentMethods: builder.query({
      query: () => ({
        url: '/payment-methods',
        method: 'GET'
      }),
      providesTags: ['SavedPaymentMethods'],
      transformResponse: (response) => response
    }),
    createSetupIntent: builder.mutation({
      query: () => ({
        url: '/payment-methods/setup-intent',
        method: 'POST'
      })
    }),
    savePaymentMethod: builder.mutation({
      query: (data) => ({
        url: '/payment-methods',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['SavedPaymentMethods']
    })
  })
});

export const {
  useGetCreditBalanceQuery,
  useGetReferralInfoQuery,
  useGetCreditPackagesQuery,
  usePurchaseCreditPackageMutation,
  useConfirmCreditPurchaseMutation,
  useGetSavedPaymentMethodsQuery,
  useCreateSetupIntentMutation,
  useSavePaymentMethodMutation
} = enhancedCreditApi;
export default enhancedCreditApi;
